import {
  GA_ACT_CLOSED_GENRES_DROPDOWN,
  GA_ACT_OPENED_GENRES_DROPDOWN
} from '@/config/events-ga/actions';
import { GA_CAT_NAVIGATION } from '@/config/events-ga/categories';

export const GAopenedGenresDropdown = () => ({
  eventCategory: GA_CAT_NAVIGATION,
  eventAction: GA_ACT_OPENED_GENRES_DROPDOWN
});

export const GAclosedGenresDropdown = () => ({
  eventCategory: GA_CAT_NAVIGATION,
  eventAction: GA_ACT_CLOSED_GENRES_DROPDOWN
});